import React from "react";
import { useNavigate } from "react-router-dom";

const HyvidApply = ({ onApplyHandler }) => {
  return (
    <div className="relative overflow-hidden gradient-effect">
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-emerald-600 rounded-2xl ca" />

      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-emerald-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-purple-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-75" />
      </div>

      <div className="text-card-foreground flex flex-col gap-6 rounded-xl relative p-8 bg-transparent border-0 shadow-none">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h3 className="text-white mb-2 font-semibold">Ready to apply?</h3>
            <p className="text-purple-100">
              Join our team and help us build amazing products
            </p>
          </div>

          <button
            onClick={onApplyHandler} 
            type="button"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap
              h-10 rounded-md px-6 text-sm font-medium transition-all
              bg-white text-purple-600 hover:bg-purple-50 shadow-lg
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HyvidApply;
